import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { API } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { Button, Confirm, useNotify, useRedirect } from "react-admin";
import { useForm } from "react-final-form";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { NoteType, OutboundStatus } from "../../../utils/constants";
import { deepRedirect, trimDecimal } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({
  record,
  resource,
  className,
  backPath,
  isSaving,
  isDeleting,
  setIsDeleting,
  ...props
}) => {
  const classes = useStyles();
  const form = useForm();
  const history = useHistory();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    debugger;
    setIsDeleting(true);
    try {
      const shipmentLineItemDeleteList = [];
      const shipmentItemInventoryItemDeleteList = [];
      const inventoryItemUpdateList = [];
      const inventoryUpdateList = [];
      const updateDate = new Date().toISOString();

      const photos = form.getFieldState("photos.items")?.value || [];

      const outboundDeleteInput = {
        id: record.id,
        carrierType: record.carrierType,
        attachments: record.attachments,
        bolFile: record.bolFile,
        photos: photos,
        timeslotId: record.timeslot?.id,
      };

      if (record.shipmentLineItems?.items?.length > 0) {
        record.shipmentLineItems.items.forEach((lineItem) => {
          shipmentLineItemDeleteList.push({ id: lineItem.id });

          if (lineItem.inventoryItems?.items?.length > 0) {
            lineItem.inventoryItems.items.forEach((invItm) => {
              shipmentItemInventoryItemDeleteList.push({
                id: invItm.id,
                shipmentLineItemId: invItm.shipmentLineItemId,
              });

              const inventoryItemToUpdate = {
                ...invItm.inventoryItem,
                updatedAt: updateDate,
              };
              debugger;
              inventoryItemToUpdate.quantityCommitted = trimDecimal(
                inventoryItemToUpdate.quantityCommitted - invItm.quantityToPick,
              );
              const historyNote = {
                type: NoteType.INVENTORY,
                text: `Deleted Outbound Qty. of ${invItm.quantityToPick} ${lineItem.inventory.inventoryUOM}`,
                date: updateDate,
                by: window.appUser?.fullName,
              };
              inventoryItemToUpdate.history = [
                ...inventoryItemToUpdate.history,
                historyNote,
              ];
              delete inventoryItemToUpdate.area;
              delete inventoryItemToUpdate.inventory;
              delete inventoryItemToUpdate.location;
              delete inventoryItemToUpdate.zone;
              inventoryItemUpdateList.push(inventoryItemToUpdate);
            });
          }

          debugger;
          const newQuantityOnHand = trimDecimal(
            lineItem.inventory.quantityCommitted - lineItem.totalQuantityToPick,
            3,
          );
          const inventoryUpdateInput = {
            ...lineItem.inventory,
            updatedAt: updateDate,
            quantityCommitted: newQuantityOnHand,
          };
          const historyNote = {
            type: NoteType.INVENTORY,
            text: `Deleted Outbound Qty. of ${lineItem.totalQuantityToPick}`,
            date: new Date(),
            by: window.appUser?.fullName,
          };
          inventoryUpdateInput.history = [
            ...inventoryUpdateInput.history,
            historyNote,
          ];

          delete inventoryUpdateInput.account;
          delete inventoryUpdateInput.area;
          delete inventoryUpdateInput.inboundShipment;
          delete inventoryUpdateInput.location;
          delete inventoryUpdateInput.notes;
          delete inventoryUpdateInput.photos;
          delete inventoryUpdateInput.product;
          delete inventoryUpdateInput.reloadYardCommodity;
          delete inventoryUpdateInput.shipmentLineItems;
          delete inventoryUpdateInput.zone;
          inventoryUpdateList.push(inventoryUpdateInput);
        });
      }
      const trackCarDeleteInput = record?.trackCar?.id
        ? { id: record.trackCar.id }
        : null;
      const response = await API.post("transREST", "/outboundDelete", {
        body: {
          outboundDeleteInput,
          shipmentLineItemDeleteList,
          shipmentItemInventoryItemDeleteList,
          inventoryItemUpdateList,
          inventoryUpdateList,
          manualChargeDeleteList: record?.manualCharges?.items,
          trackCarDeleteInput,
          user: window.appUser.email,
          reloadYardId: window.appUser.reloadYardId,
        },
      });
      if (response.error) throw response.error;

      notify("Outbound deleted successfully", "success");
      deepRedirect(history, backPath);
    } catch (err) {
      logError(
        "outboundShipment:DeepDeleteButton:handleDelete",
        err,
        notify,
        redirect,
      );
    } finally {
      setIsDeleting(false);
    }
  };

  if (
    !record ||
    record.status === OutboundStatus.LOADED ||
    record.status === OutboundStatus.RELEASED
  )
    return null;
  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={isDeleting || isSaving}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={isDeleting}
        title={"Delete Confirmation"}
        content={"Are you sure you want to delete this Outbound Shipment?"}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
